var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplicationMedia.jinja');
require('./ProductionDesignInitiativeApplicationMedia.less');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    events: {
        'blur .ProductionDesignInitiativeApplicationMedia-input': 'getVideoInfo',
        'keyup .ProductionDesignInitiativeApplicationMedia-input': 'onVideoCodeKeyUp',
        'click .ProductionDesignInitiativeApplicationMedia-preview': 'getVideoInfo',
        'click .ProductionDesignInitiativeApplicationMedia-delete': 'deleteItem'
    },

    embedApi: function () {
        return (Urls['front:api:oembed']());
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this,  'embedApi');

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.videoXHR && this.videoXHR.abort();

        return Base.prototype.deactivate.call(this, params);
    },


    getData: function () {
        var $inputUrl = this.$('.ProductionDesignInitiativeApplicationMedia-input');
        var videoUrl = $inputUrl.val();
        var videoCode = $inputUrl.attr('data-code');
        var videoProvider = $inputUrl.attr('data-provider');

        return {
            'videoUrl': videoUrl,
            'videoCode': videoCode,
            'videoProvider': videoProvider
        };
    },


    onVideoCodeKeyUp: function (e) {
        if (e.keyCode == 13) {
            this.getVideoInfo();
        }
    },


    getVideoInfo: function () {
        var $inputUrl = this.$('.ProductionDesignInitiativeApplicationMedia-input');
        var $previewButton = this.$('.ProductionDesignInitiativeApplicationMedia-preview');
        var $embed = this.$('.ProductionDesignInitiativeApplicationMedia-embed');
        var self = this;

        $previewButton.addClass('Button--loading');
        $inputUrl.attr('data-code', '');

        this.videoXHR && this.videoXHR.abort();

        this.videoXHR = $.ajax({
            type: 'GET',
            url: this.embedApi(),
            dataType: 'json',
            data: {url: $inputUrl.val()},
            success: function (data) {
                if (!data || data.error) {
                    self.$el.removeClass('ProductionDesignInitiativeApplicationMedia--hasMedia');
                    $previewButton.removeClass('Button--loading');

                    return;
                }

                $inputUrl.attr('data-code', data.code);
                $inputUrl.attr('data-provider', data.provider);
                $embed.html(data.code);

                self.$el.addClass('ProductionDesignInitiativeApplicationMedia--hasMedia');
                $previewButton.removeClass('Button--loading');
            },
            error: function () {
                console.log(arguments);
                self.$el.removeClass('ProductionDesignInitiativeApplicationMedia--hasMedia');
                $previewButton.removeClass('Button--loading');
            }
        });
    },


    deleteItem: function (e) {
        this.remove();

        this.trigger('delete');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia.js
// module id = 238
// module chunks = 0